<template>
    <div class="pai-bg">
        <div class="pai-container">
            <div class="pai-title">拍品送拍</div>
            <div class="pai-from">
                <label class="pai-input"><span>拍品名称：</span><input type="text" v-model="form.title"></label>
                <label class="pai-input">
                    <span>拍品照片：</span>
                    <input type="file" @change="getFile($event)">
                    <img class="pai-images" style="width:auto" v-show="form.images" :src="form.images">
                </label>
                <label class="pai-input"><span>拍品估价：</span><input type="text" v-model="form.price"></label>
                <label class="pai-input"><span>拍品介绍：</span><textarea v-model="form.description"></textarea></label>
                <label class="pai-input"><span>联系人：</span><input type="text" v-model="form.name"></label>
                <label class="pai-input"><span>联系方式：</span><input type="text" v-model="form.tel"></label>
                <button @click="subForm">提交拍品</button>
            </div>
        </div>
    </div>
</template>
<script>
import qs from 'qs';

export default {
    metaInfo: {
        title: "拍界——唤醒您的沉睡资产",
        meta: [{
            name: "keywords",
            content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
        }, {
            name: "description",
            content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
        }]
    },
    data (){
        return{
            form: {
                images: '',
                title: '',
                price: '',
                name: '',
                tel: '',
                description: '',
            },
        }
    },
    created(){
        // 显示公共栏
        this.$emit('header', true)
        this.$emit('footer', true)
        // 页面至顶部
        window.scrollTo(0,0);
    },
    methods: {
        subForm: function(){
            let forms = qs.stringify({
                    title: this.form.title,
                    price: this.form.price,
                    name: this.form.name,
                    tel: this.form.tel,
                    images: this.form.images,
                    description: this.form.description
                })
            this.axios.post(this.$global.apiUrl.subject_collect, forms, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                .then((response) => {
                    if (response.data.error.code == 0){
                        this.$alert('提交成功', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.$router.go(0)
                            }
                        })
                    }
                    else{
                        this.$alert(response.data.error.message, '提示', {
                            confirmButtonText: '确定'
                        })
                    }
                })
        },
        getFile: function(event){
			const file = event.target.files[0]
			//请求接口前需要传的参数
			let formData = new FormData()
			formData.append('file', file)
			this.axios.post(this.$global.apiUrl.subject_collect_file, formData, {
				headers: {
					'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
				}
			})
			.then((response) => {
				if(response.data.error.code == 0){
					this.form.images = response.data.url
				} else {
                    this.$alert(response.data.error.message, '提示', {
                        confirmButtonText: '确定'
                    })
                }
			})
			.catch(() => {})
		},
    },
    mounted(){
        
    },
    computed: {

    }
}
</script>
<style scoped>
.pai-bg {
    width: 1200px;
    height: 675px;
    background: url("../assets/images/pai_bg.png");
}
.pai-container {
    width: 450px;
    min-height: 500px;
    box-shadow: 0px 5px 5px 3px #888888;
    margin: 50px 0 0 650px;
    padding-bottom: 30px;
    background: #FFFFFF;
}
.pai-title {
    font-size: 18px;
    color: #c71622;
    height:50px;
    line-height:50px;
    border-bottom: 2px solid #adadad;
}
.pai-input {
    display: block;
    margin-top: 20px;
    text-align: right;
}
.pai-input span {
    margin-right: 20px;
    line-height: 30px;
    vertical-align: top;
}
.pai-input input {
    padding:6px 10px;
    border:solid 1px #cccccc;
    margin-right: 70px;
    width: 200px;
}
.pai-input textarea {
    padding:6px 10px;
    border:solid 1px #cccccc;
    margin-right: 70px;
    width: 200px;
    height:50px;
    vertical-align: top;
}
.pai-input .pai-images {
    height:100px;
    margin-right: 70px;
    margin-top:10px;
}
.pai-from button {
    width: 198px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 16px;
    border: 1px solid transparent;
    background: #d6363b;
    color: #fff;
    cursor: pointer;
    border-radius: 4px;
    margin-top: 20px;
}
@media screen and (max-width: 540px){
    .pai-bg {
        width: 100%;
        height: 675px;
        background: url("../assets/images/pai_bg.png");
    }
    .pai-container {
        width: 330px;
        min-height: 500px;
        box-shadow: 0px 5px 5px 3px #888888;
        margin: 50px auto;
        padding-bottom: 30px;
        background: #FFFFFF;
    }
    .pai-title {
        font-size: 18px;
        color: #c71622;
        height:50px;
        line-height:50px;
        border-bottom: 2px solid #adadad;
    }
    .pai-input {
        display: block;
        margin-top: 20px;
        text-align: right;
    }
    .pai-input span {
        margin-right: 15px;
        line-height: 30px;
        vertical-align: top;
    }
    .pai-input input {
        padding:6px 10px;
        border:solid 1px #cccccc;
        margin-right: 25px;
        width: 160px;
    }
    .pai-input textarea {
        padding:6px 10px;
        border:solid 1px #cccccc;
        margin-right: 25px;
        width: 160px;
        height:50px;
        vertical-align: top;
    }
}
</style>